import { drawCoordinates, drawLineCoordinates } from "./drawFunctions";

function generateCanvaImage(
  canvas,
  currentCamera,
  drawMode,
  items,
  editMode,
  itemBeingEdited
) {
  const img = new Image();
  img.src = currentCamera.image;

  canvas.width = currentCamera.width;
  canvas.height = currentCamera.height;
  const context = canvas.getContext("2d");
  context.drawImage(img, 0, 0, canvas.width, canvas.height);

  drawMode === "zone"
    ? drawCoordinates(context, items, editMode, itemBeingEdited, canvas, false)
    : drawLineCoordinates(
        context,
        items,
        editMode,
        itemBeingEdited,
        canvas,
        false
      );

  const dataUrl = canvas.toDataURL("image/png");

  return dataUrl;
}

function updateTable(
  id,
  description,
  configId,
  drawMode,
  tableData,
  items,
  setTableData,
  setItems,
  setZoneCollection,
  setItemDescription,
  setId,
  currentColor,
  setCurrentColor,
  colorIndex,
  setColorIndex,
  canvas,
  savedCanvas,
  camerasToEdit,
  currentCamera,
  editMode,
  itemBeingEdited,
  VIBRANT_COLORS,
  setSavedCanvas
) {
  if (drawMode === "zone") {
    setTableData([
      ...tableData,
      {
        key: id,
        zone: description ? description : `Zona ${id}`,
        identification: currentColor,
        configuration: configId,
      },
    ]);

    const index = items.findIndex((zone) => zone.id === id);
    const new_zones = [...items];
    new_zones[index].description = description ? description : `Zona ${id}`;
    new_zones[index].configuration = configId;
    setItems(new_zones);

    setZoneCollection([]);
    setItemDescription("");
  } else if (drawMode === "line") {
    setTableData([
      ...tableData,
      {
        key: id,
        line: description ? description : `Entrada ${id}`,
        identification: id,
      },
    ]);

    const index = items.findIndex((line) => line.id === id);
    const new_lines = [...items];
    new_lines[index].description = description ? description : `Entrada ${id}`;
    setItems(new_lines);

    setItemDescription("");
  }

  setId(id + 1);
  setCurrentColor(VIBRANT_COLORS[colorIndex + 1].code);
  setColorIndex(colorIndex + 1);

  if (savedCanvas.length === camerasToEdit.length) {
    const dataUrl = generateCanvaImage(
      canvas,
      currentCamera,
      drawMode,
      items,
      editMode,
      itemBeingEdited
    );
    const existingCameraIndex = savedCanvas.findIndex(
      (camera) => camera.id === currentCamera.id
    );
    const updatedCanvas = [...savedCanvas];
    updatedCanvas[existingCameraIndex].imageUrl = dataUrl;
    setSavedCanvas(updatedCanvas);
  }

  if (drawMode === "zone") {
    drawCoordinates(
      canvas.getContext("2d"),
      items,
      editMode,
      itemBeingEdited,
      canvas
    );
  } else if (drawMode === "line") {
    drawLineCoordinates(
      canvas.getContext("2d"),
      items,
      editMode,
      itemBeingEdited,
      canvas
    );
  }
}

export { generateCanvaImage, updateTable };
